<p>
  책장 삭제 시, 책장 및 책장 내 책 목록은
  <b>복구할 수 없습니다.</b> 삭제하시겠습니까?
</p>
<div class="actions">
  <button
    sui-solid-button
    varSize="large"
    [class.inactive]="_isSaving"
    [disabled]="_isSaving"
    [attr.aria-busy]="_isSaving"
    (click)="_onClickDelete()"
  >
    <span class="save-button-inner">
      <mat-spinner
        *ngIf="_showSubmitLoadingIndicator"
        class="save-button-spinner"
        diameter="18"
      ></mat-spinner>
      <span [class.save-button-label--hidden]="_showSubmitLoadingIndicator"
        >삭제하기</span
      >
    </span>
  </button>
</div>
